import React from "react";

import "./styles/Story.css";

const Story = props => {
  return (
    <div className="story">
      <figure className="story__shape">
        <img className="story__image" src={props.src} alt={props.title} />
        <div className="story__caption">{props.figcaption}</div>
      </figure>
      <div className="story__text">
        <h3 className="heading-tertiary">{props.title}</h3>
        <p className="description">{props.description}</p>
      </div>
    </div>
  );
};

export default Story;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Stories/Story.js